export default "/images/image-bottom2.jpg?8f61863beebc6a553b18454654f64de8";